import { useState } from 'react'
import {
  Dialog, DialogContent, DialogHeader, DialogTitle, DialogDescription, DialogFooter,
  Button, Textarea,
} from '@/components/ui'
import { X } from 'lucide-react'
import { useEffect } from 'react'

interface Props {
  phaseName: string
  open: boolean
  onOpenChange: (open: boolean) => void
  onConfirm: (reason: string) => void
  isPending?: boolean
  initialReason?: string
}

export function RejectPhaseModal({ phaseName, open, onOpenChange, onConfirm, isPending, initialReason }: Props) {
  const [reason, setReason] = useState('')

  useEffect(() => {
    if (open) {
      setReason((initialReason ?? '').trim())
    }
  }, [open, initialReason])

  const handleConfirm = () => {
    if (!reason.trim()) return
    onConfirm(reason.trim())
    setReason('')
  }

  const handleOpenChange = (open: boolean) => {
    if (!open) setReason('')
    onOpenChange(open)
  }

  return (
    <Dialog open={open} onOpenChange={handleOpenChange}>
      <DialogContent data-testid="reject-phase-modal">
        <DialogHeader>
          <DialogTitle className="flex items-center gap-2 text-red-60 pb-4">
            Reject Phase Gate
          </DialogTitle>
          <DialogDescription>
            Are you sure you wan't to reject this phase?
          </DialogDescription>
          <DialogDescription>
            Rejecting &ldquo;{phaseName}&rdquo; will stop the workflow. The workflow will not continue until the issues are resolved.
          </DialogDescription>
        </DialogHeader>
        <div className="space-y-2">
          <label htmlFor="rejection-reason" className="text-sm font-medium mb-2">
            Rejection Reason <span className="text-red-500">*</span>
          </label>
          <Textarea
            id="rejection-reason"
            placeholder="Explain why this phase is being rejected..."
            value={reason}
            onChange={(e) => setReason(e.target.value)}
            rows={3}
          />
        </div>
        <DialogFooter>
          <Button variant="outline" onClick={() => handleOpenChange(false)}>Cancel</Button>
          <Button
            variant="destructive"
            onClick={handleConfirm}
            disabled={!reason.trim() || isPending}
          >
            <X className="h-3 w-3 mr-1" /> Reject Phase
          </Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  )
}
